"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import type { ContactHeroContent } from "@/features/contact/types/contact-page-content";
interface ContactHeroProps {
  content: ContactHeroContent;
}
export function ContactHero(t0) {
  const $ = _c(15);
  const {
    content
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div aria-hidden={true} className="pointer-events-none absolute top-0 left-1/2 h-[480px] w-[900px] -translate-x-1/2 rounded-full" style={{
      background: "radial-gradient(ellipse at 50% 0%, rgba(49,136,190,0.18) 0%, transparent 70%)"
    }} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0,
      y: 16
    };
    t3 = {
      opacity: 1,
      y: 0
    };
    t4 = {
      duration: 0.6,
      ease: "easeOut"
    };
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="h-1.5 w-1.5 rounded-full bg-secondary" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== content.eyebrow) {
    t6 = <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-secondary/25 bg-secondary/10 px-4 py-1.5">{t5}<span className="text-xs font-semibold tracking-wider text-secondary uppercase">{content.eyebrow}</span></div>;
    $[5] = content.eyebrow;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== content.title) {
    t7 = <h1 className="text-5xl leading-[1.05] font-semibold tracking-tight whitespace-pre-line text-white sm:text-6xl md:text-7xl lg:text-[5.5rem]">{content.title}</h1>;
    $[7] = content.title;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== content.description) {
    t8 = <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/55">{content.description}</p>;
    $[9] = content.description;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t7 || $[13] !== t8) {
    t9 = <div className="relative w-full overflow-hidden bg-[#0b1416] pt-40 pb-28 sm:pt-48 sm:pb-36">{t1}<div className="relative mx-auto max-w-4xl px-6 text-center lg:px-8"><motion.div initial={t2} animate={t3} transition={t4}>{t6}{t7}{t8}</motion.div></div></div>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}